class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.toggleAddButton(true, '', false);
    this.getInitialVariant()
  }

  getInitialVariant () {
    const variantData = this.getVariantData();
    const query = new URLSearchParams(window.location.search);
    const selectedVariantId = query.get('variant');

    this.currentVariant = variantData.find((variant) => `${variant.id}` === selectedVariantId) ?? variantData?.[0];

    this.onVariantChange({}, true)
  }

  onVariantChange(event, onLoad = false) {
    if (!onLoad) {
      this.updateOptions();
      this.updateMasterId();
    }

    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();

    const regularPriceElem = document.querySelectorAll('.rc-radio__label .regular-price');
    if (regularPriceElem.length > 0) regularPriceElem.forEach((e) => e.classList.add('loading'))

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('.js-quantity-radio input[name="quantity-selector"]:checked'), (radio) => radio.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => { parent.scroll(0, 0) });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));

      const addButton = productForm.querySelector('.product-form__submit');

      addButton && addButton.setAttribute('data-variant', this.currentVariant.id);
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    this.toggleAddButton(!this.currentVariant.available, this.currentVariant.available ? window.variantStrings.addToCart : window.variantStrings.backInStock)

    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const idMobile = `price-mobile-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const destinationMobile = document.getElementById(idMobile);
        const source = html.getElementById(id);
        const sourceMobile = html.getElementById(idMobile);
        const sourceMobilePrice = sourceMobile?.querySelector('.price');
        const mobilePriceVariantText = document.querySelector('.mobile-price__variant-text');

        if (source && destination && !this.inRechargeWidget(destination))
          destination.innerHTML = source.innerHTML;

        if (sourceMobile && destinationMobile && !this.inRechargeWidget(destinationMobile)) {
          destinationMobile.innerHTML = sourceMobile.innerHTML;
        }

        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');

        const mobileAddToCart = document.getElementById('mobile-product-form__submit');
        mobileAddToCart?.appendChild(sourceMobilePrice);

        return source
      })
      .then((source) => {
        const subscriptionRadio = document.querySelectorAll('.rc-widget-injection-parent .rc-radio');
        const salePrice = source.querySelector('.price__sale .price-item--regular')

        if (subscriptionRadio && salePrice.innerText.trim().length > 0) {
          subscriptionRadio.forEach((radio) => {
            const regularPriceSpan = radio.querySelector('.regular-price')
            regularPriceSpan.classList.remove('hidden')
            if (regularPriceSpan != null) regularPriceSpan.innerHTML = salePrice.textContent.trim()

            const priceElem = radio.querySelector('.rc-radio__label .rc-option__price')
            const priceElemWidth = priceElem.getBoundingClientRect().width;
            radio.querySelector('.rc-radio__label').style.setProperty('--regular-price-width', `${priceElemWidth}px`)
          })
        } else if (salePrice.innerText.trim().length <= 0) {
          const regularPrice = source.querySelector('.price__regular .price-item--regular')
          subscriptionRadio.forEach((radio) => {
            const regularPriceSpan = radio.querySelector('.regular-price')
            if (regularPriceSpan != null) regularPriceSpan.innerHTML = regularPrice.textContent.trim()
            if (radio.hasAttribute('data-option-onetime')) regularPriceSpan.classList.add('hidden')

            const priceElem = radio.querySelector('.rc-radio__label .rc-option__price')
            const priceElemWidth = priceElem.getBoundingClientRect().width;
            radio.querySelector('.rc-radio__label').style.setProperty('--regular-price-width', `${priceElemWidth}px`)
          })
        }
      })
      .finally(() => {

        const regularPriceElem = document.querySelectorAll('.rc-radio__label .regular-price');
        if (regularPriceElem.length > 0) regularPriceElem.forEach((e) => e.classList.remove('loading'))
      });
  }

  inRechargeWidget(element) {
    const priceWrapper = element.closest('.product__price-variant-wrapper')
    return priceWrapper?.hasAttribute('data-price-mutation-watcher') ? true : false
  }

  toggleAddButton(disable = false, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    const isRcActive = document.querySelector('[data-option-subsave]')?.classList.contains('rc_widget__option--active');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('type', 'button');
      addButton.classList.add('klaviyo-bis-trigger');
      if (text) addButton.textContent = text;
    } else {
      addButton.setAttribute('type', 'submit');
      addButton.classList.remove('klaviyo-bis-trigger');
      if (isRcActive) {
        addButton.textContent = window.variantStrings.subscribe;
      } else {
        addButton.textContent = window.variantStrings.addToCart;
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);
